class ForgotpasswordController {
  constructor(User) {
    "ngInject";
    this.name = 'forgotpassword';
    this.User = User;
  }

  sendResetLink(email) {
    this.loading = true;
    this.User.sendPasswordResetEmail(email)
      .then((data) => {
        this.loading = false;
        console.log("password reset link sent");
        this.showMessage('password reset link sent, please check your inbox:)');
      })
      .catch((err) => {
        console.log("error" + err);
        this.loading = false;
        this.showMessage(err.message);
      })
  }

  showMessage(msg) {
    this.alert = msg;
  }

}

export default ForgotpasswordController;



// WEBPACK FOOTER //
// ./client/app/components/auth/forgotpassword/forgotpassword.controller.js